import logoUrl from '@interviewgator/brand/logo.png?url';
import { cn } from '../../lib/utils.js';

type Props = {
  className?: string;
  /** Use empty string when nearby text already labels the mark. */
  alt?: string;
};

/**
 * Resolve Vite's root-relative asset path (e.g. `/assets/logo-abc.png`) to an
 * absolute URL. Harmless everywhere, but required for the Gotenberg PDF render:
 * its headless Chromium must always resolve the mark to a real URL rather than
 * a broken placeholder.
 */
const absoluteLogoUrl =
  typeof window !== 'undefined' ? new URL(logoUrl, window.location.origin).href : logoUrl;

/**
 * Circular accent variant of the gator mark used in hero/bubble UI.
 */
export function GatorMarkCircle({ className, alt = 'InterviewGator' }: Props) {
  return (
    <img
      src={absoluteLogoUrl}
      alt={alt}
      className={cn('shrink-0 overflow-hidden rounded-full object-cover', className)}
      decoding="async"
    />
  );
}
